













import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * The warning glyph that sits beside a cart line's title when that line came
 * from NetSuite with a configuration rebuilt from its SKU. It repeats on every
 * product-type branch of the cart line template, so it lives here to keep the
 * tooltip copy in one place. Clicking it opens the line for editing, same as
 * the pencil icon and the "Review for accuracy" link under the SKU — all three
 * are the same affordance, so all three go to the same place.
 */
@Component
export default class AccuracyWarningIcon extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({
    default:
      "This line item was added to your quote in Netsuite. Please review it for accuracy."
  })
  title!: string;
}
